export default function getInt(num: string): number | null {
    let parsed = parseInt(num, 10);
    parsed = isNaN(parsed) ? null : parsed;
    parsed = isFinite(parsed) ? parsed : null;
    return parsed;
}